// Components
import { Loading } from "components"
import { FormSectionSpendMoney, Print } from "./components"

// Contexts
import { ListJournalProvider } from "../contexts"

// Form
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"

// Third-Party Libraries
import toast from "react-hot-toast"
import { useParams, useNavigate } from "react-router"

// Utils
import { useApi, usePermission } from "utils"
import { useTaxCodeList } from "../GeneralEntry/utils/hooks"
import { getAcc, useDetail } from "../utils"
import { FormEditType, formParams, getFinalValue, validationSchemaEditSpend } from "./utils"
import { PERMISION } from "security"

export default function EditSpendMoney() {
  // Hooks
  const { data_source, data_source_id } = useParams()
  const { data, isLoading } = useDetail(data_source!, data_source_id!)

  if (isLoading || !data) {
    return <Loading loading={isLoading} errorText="No Data Available" />
  }
  return <DataSection data={data} />
}

function DataSection(params: { data: FormEditType }) {
  // Hooks
  const api = useApi()
  const navigate = useNavigate()
  const permission = usePermission([PERMISION.FINANCE.TRANSACTION.SPEND_MONEY.PERMISION])
  const taxCodeList = useTaxCodeList()

  // Form  
  const methods = useForm<FormEditType>({
    defaultValues: params.data,
    resolver: yupResolver(validationSchemaEditSpend)
  })

  const onSubmit = (value: FormEditType) => {
    // Hooks
    const { sub_total, tax } = getAcc(value.datajournal)

    return new Promise<void>((resolve) => {
      // if (!value.tax_inclusive && value.amount + tax > value.balance) {
      //   toast.error("Credit & all Tax must be lower or equal to Balance")
      //   return resolve()
      // }

      if (Math.abs(value.amount - (sub_total + (value.tax_inclusive ? tax : 0))) !== 0) {
        toast.error("Balance must be 0")
        return resolve()
      }

      toast.promise(
        api.put("/spendmoney/update", {
          financeid: value.financeid,
          journal_code: value.journal_code,
          ...getFinalValue(value, taxCodeList.data)
        }),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.detail?.message ?? err.response.data.message
        }
      ).then(() => {
        navigate("/finance/journal")
      }).catch(() => {}).finally(resolve)
    })
  }

  return (
    <FormProvider {...methods}>
      <ListJournalProvider
        is_enabled
        data_source={formParams.dataSource}
        date={params.data.transaction_date}
        journal_code={params.data.journal_code}
      >
        <FormSectionSpendMoney
          {...formParams}
          isEdit
          onSubmit={methods.handleSubmit(onSubmit)}
          permission={permission}
          print={<Print />}
        />
      </ListJournalProvider>
    </FormProvider>
  )
}